import { useState } from "react";

export default function Simple({
  placeholder = "",
  type,
  id,
  formValue,
  formOnChange,
  emailBlur,
  setEmailBlur,
  emailValid,
  readOnly = false,
  isNumeric = false,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue =
    formValue !== undefined && formValue !== null && String(formValue).length > 0;
  const isLabelActive = isFocused || hasValue;

  return (
    <div
      style={
        emailBlur && !emailValid ? { border: "0.5px solid #fbbf24" } : null
      }
      className="relative w-full h-[42px] border bg-transparent dark:bg-zi-inputbg-dark border-zi-border-light dark:border-none rounded-lg flex items-center overflow-visible hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-dark/50"
    >
      <input
        type={type}
        id={id}
        placeholder=""
        className="zi-input-autofill text-sm w-full h-full px-3 outline-none bg-transparent text-zi-text-light dark:text-zi-text-dark [direction:ltr] text-start"
        value={formValue}
        onFocus={() => {
          setIsFocused(true);
          if (!setEmailBlur) return;
          setEmailBlur(false);
        }}
        onBlur={() => {
          setIsFocused(false);
          if (!setEmailBlur) return;
          setEmailBlur(true);
        }}
        onChange={formOnChange}
        readOnly={readOnly}
        inputmode={isNumeric ? "numeric" : undefined}
        pattern={isNumeric ? "[0-9]*" : undefined}
      ></input>
      {placeholder && (
        <label
          htmlFor={id}
          className={`zi-floating-label pointer-events-none absolute right-2 z-10 origin-right px-1 leading-none transition-all duration-200 ease-in-out ${
            isLabelActive
              ? "top-0 -translate-y-1/2 text-xs text-zi-blue-light dark:text-zi-text-dark dark:bg-zi-inputbg-dark rounded-lg px-2.5 py-1"
              : "top-1/2 -translate-y-1/2 text-sm text-zi-text-light/50 dark:text-zi-text-dark/50 dark:bg-zi-inputbg-dark rounded-lg px-2.5 py-1"
          }`}
        >
          {placeholder}
        </label>
      )}
    </div>
  );
}
